type EventHandler = (...args: any[]) => void

export class EventCenter {
  private events: Record<string, EventHandler[]> = {}

  on(event: string, handler: EventHandler) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(handler)
  }

  off(event: string, handler?: EventHandler) {
    if (!handler) {
      delete this.events[event]
      return
    }
    this.events[event] = this.events[event]?.filter((h) => h !== handler) || []
  }

  emit(event: string, ...args: any[]) {
    this.events[event]?.forEach((handler) => {
      try {
        handler(...args)
      } catch (e) {
        console.error(`Event ${event} handler error:`, e)
      }
    })
  }

  once(event: string, handler: EventHandler) {
    const onceHandler = (...args: any[]) => {
      handler(...args)
      this.off(event, onceHandler)
    }
    this.on(event, onceHandler)
  }
}
